<template>
  <div class="news">
    <navigator :items="items"></navigator>
    <div class="container">
      <div class="row">
        <div class="col-12">
          <div class="card">
            <div class="container-fluid">
              <div class="row">
                <div class="col-12">
                  <div class="title-section">Conteúdo da Notícia</div>
                </div>
              </div>
              <div class="row">
                <div class="col-12">
                  <div class="form-group">
                    <label>
                      Título
                      <span class="required-field">*</span>
                    </label>
                    <input
                      type="text"
                      v-model="news.title"
                      class="form-control"
                    />
                  </div>
                </div>
                <div class="col-12">
                  <div class="form-group">
                    <label>
                      Chamada
                      <span class="required-field">*</span>
                    </label>
                    <textarea
                      v-model="news.short_title"
                      cols="30"
                      rows="4"
                      class="form-control"
                    ></textarea>
                  </div>
                </div>
                <div class="col-12" v-if="news.content || formType == 'create'">
                  <div class="form-group">
                    <label>
                      Texto
                      <span class="required-field">*</span>
                    </label>
                    <text-editor-component
                      :textContent="news.content"
                      @updateContentComponent="updateContent"
                    ></text-editor-component>
                  </div>
                </div>

                <div class="col-lg-6 col-12">
                  <div class="form-group">
                    <label for>Fonte</label>
                    <vue-simple-suggest
                      v-model="news.reference"
                      @input="getFonts"
                      :debounce="200"
                      :list="fonts"
                      :value-attribute="reference"
                      :styles="autoCompleteStyle"
                      :display-attribute="reference"
                      :filter-by-query="true"
                    ></vue-simple-suggest>
                  </div>
                </div>

                <div class="col-lg-6 col-12">
                  <div class="form-group">
                    <label for>Link da Fonte</label>
                    <input
                      type="text"
                      class="form-control"
                      v-model="news.reference_url"
                    />
                  </div>
                </div>
                <div
                  class
                  v-bind:class="{
                    'col-lg-9': news.image_url,
                    'col-lg-12': !news.image_url,
                  }"
                >
                  <div class="form-group">
                    <label for>{{
                      news.image_url
                        ? "Alterar imagem de capa"
                        : "Imagem de capa"
                    }}</label>
                    <b-form-file
                      placeholder="Escolha uma imagem"
                      drop-placeholder="Arraste a imagem aqui..."
                      browse-text="Procurar"
                      accept="image/jpeg, image/png, image/jpg"
                      v-on:change="uploadFile"
                    ></b-form-file>
                  </div>
                </div>
                <div class="col-lg-3" v-if="news.image_url">
                  <div
                    class="
                      w-100
                      h-100
                      d-flex-align-items-center
                      justify-content-end
                    "
                    style="padding-top: 32px"
                  >
                    <a
                      :href="news.image_url"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <button class="btn btn-primary float-right">
                        Ver imagem atual
                      </button>
                    </a>
                  </div>
                </div>
                <div class="col-lg-4 col-12">
                  <div class="form-group">
                    <label>Data de publicação da fonte</label>
                    <b-form-datepicker
                      id="reference-datepicker"
                      v-model="news.reference_date"
                      placeholder="Escolha uma data"
                      class="mb-2"
                    ></b-form-datepicker>
                  </div>
                </div>
                <div class="col-lg-4 col-12">
                  <div class="form-group">
                    <label>
                      Data de publicação no site
                      <span class="required-field">*</span>
                    </label>
                    <b-form-datepicker
                      id="site-datepicker"
                      v-model="news.news_date"
                      placeholder="Escolha uma data"
                      class="mb-2"
                    ></b-form-datepicker>
                  </div>
                </div>
                <div class="col-lg-4 col-12">
                  <div class="form-group">
                    <label for style="color: transparent">Placeholder</label>
                    <div
                      class="
                        d-flex
                        align-items-center
                        justify-content-end
                        toggle-input
                      "
                    >
                      <label for>
                        Destaque na página inicial
                        <span class="required-field">*</span>
                      </label>
                      <toggle-button
                        v-model="news.highlighted"
                        v-bind:key="news.highlighted"
                      />
                    </div>
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col-12">
                  <button
                    class="btn btn-primary float-left"
                    v-on:click="destroy(news.id)"
                  >
                    Deletar
                  </button>
                  <button
                    class="btn btn-primary float-right"
                    v-on:click="save()"
                  >
                    Salvar
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "@/api/axios";
import TextEditorComponent from "@/components/inputs/TextEditorComponent";
import validator from "@/imports/validator/validate";
import news_validate from "@/imports/validator/models/news";
import Swal from "sweetalert2";
import { bus } from "@/main";
import VueSimpleSuggest from "vue-simple-suggest";

export default {
  name: "news",
  props: {
    id: Number,
  },
  components: {
    TextEditorComponent,
    VueSimpleSuggest,
  },
  data() {
    return {
      font: "",
      mode: "input",
      reference: "reference",
      fonts: [],
      items: [
        {
          text: "Notícias",
          route: "admin.list-news",
        },
        {
          text: "Nova Notícia",
          active: true,
        },
      ],
      autoCompleteStyle: {
        defaultInput: "form-control",
        inputWrapper: "",
        suggestItem: "list-group-item",
      },
      news: {},
      tempFile: "",
      formType: "create",
    };
  },
  mounted() {
    bus.$emit("changeLoading", true);
    this.turnOfLoader();
  },
  methods: {
    turnOfLoader: function () {
      if (this.id) {
        this.formType = "edit";
        this.getDataObject(this.id);
      } else {
        bus.$emit("changeLoading", false);
      }
    },
    getDataObject: function (id) {
      axios
        .get(`${process.env.VUE_APP_API_HOST}/api/news/${id}`)
        .then((response) => {
          this.news = response.data;
          this.items[1].text = this.news.title;
          bus.$emit("changeLoading", false);
        });
    },
    updateContent: function (val) {
      this.news.content = val;
    },
    getFonts: function () {
      axios
        .post(`${process.env.VUE_APP_API_HOST}/api/get_fonts`, {
          filter: this.news.reference,
        })
        .then((response) => {
          this.fonts = response.data;
        });
    },

    uploadFile: function (e) {
      const file = e.target.files[0];
      if (!file.type.includes("image/")) {
        return;
      }
      if (typeof FileReader === "function") {
        const reader = new FileReader();
        reader.onload = (event) => {
          this.tempFile = event.target.result;
        };
        reader.readAsDataURL(file);
      }
    },
    save: function () {
      let errors = validator.validate(this.news, news_validate.model);
      if (errors.length == 0) {
        if (this.tempFile != "") this.news.image = this.tempFile;

        delete this.news.image_url;

        let promise =
          this.formType == "create"
            ? axios.post(`${process.env.VUE_APP_API_HOST}/api/news`, this.news)
            : axios.put(
                `${process.env.VUE_APP_API_HOST}/api/news/${this.news.id}`,
                this.news
              );
        bus.$emit("changeLoading", true);
        promise
          .then((response) => {
            if (response.data.id) {
              bus.$emit("changeLoading", false);
              Swal.fire({
                title:
                  this.formType == "create"
                    ? "Nova notícia cadastrada"
                    : "Notícia alterada com sucesso",
                icon: "success",
                onClose: () => {
                  this.$router.push({ name: "admin.list-news" });
                },
              });
            }
          })
          .catch((error) => {
            bus.$emit("changeLoading", false);
            Swal.fire({
              title: "Ocorreu um erro.",
              icon: "error",
            });
          });
      } else {
        let html = "Preencha todos os campos obrigatórios.";
        if (errors.length < 4) {
          html = "";
          errors.forEach((el) => (html += el.message + "<br>"));
        }
        Swal.fire({
          title: "Atenção",
          html: html,
          icon: "warning",
        });
      }
    },
    destroy: function (id) {
      Swal.fire({
        title: "Você tem certeza que deseja excluir esse item?",
        icon: "question",
        showCancelButton: true,
        confirmButtonText: "Sim",
        cancelButtonText: "Não",
      }).then((result) => {
        if (result.value) {
          bus.$emit("changeLoading", true);
          let promise = axios.delete(
            `${process.env.VUE_APP_API_HOST}/api/news/${id}`
          );

          promise.then((response) => {
            bus.$emit("changeLoading", false);
            Swal.fire({
              title: "Item excluído com sucesso",
              icon: "success",
              onClose: () => {
                this.$router.push({ name: "admin.list-news" });
              },
            });
          });
        }
      });
    },
  },
};
</script>

<style lang="scss">
@import "@/styles/General.scss";
.vue-simple-suggest > ul {
  list-style: none;
  margin: 0;
  padding: 0;
}

.vue-simple-suggest.designed {
  position: relative;
}

.vue-simple-suggest.designed,
.vue-simple-suggest.designed * {
  box-sizing: border-box;
}

.vue-simple-suggest.designed .input-wrapper input {
  display: block;
  width: 100%;
  padding: 10px;
  border: 1px solid #cde;
  border-radius: 3px;
  color: black;
  background: white;
  outline: none;
  transition: all 0.1s;
  transition-delay: 0.05s;
}

.vue-simple-suggest.designed.focus .input-wrapper input {
  border: 1px solid #aaa;
}

.vue-simple-suggest.designed .suggestions {
  position: absolute;
  left: 0;
  right: 0;
  top: 100%;
  top: calc(100% + 5px);
  border-radius: 3px;
  border: 1px solid #aaa;
  background-color: #fff;
  opacity: 1;
  z-index: 1000;
}

.vue-simple-suggest.designed .suggestions .suggest-item {
  cursor: pointer;
  user-select: none;
}

.vue-simple-suggest.designed .suggestions .suggest-item,
.vue-simple-suggest.designed .suggestions .misc-item {
  padding: 5px 10px;
}

.vue-simple-suggest.designed .suggestions .suggest-item.hover {
  background-color: #f44336 !important;
  color: #fff !important;
}

.vue-simple-suggest.designed .suggestions .suggest-item.selected {
  background-color: #e12323;
  color: #fff;
}
.form-control-search {
  width: 100%;
  height: calc(1.5em + 0.75rem + 2px);
  padding: 0.375rem 0.75rem;
  font-size: 1rem;
  font-weight: 400;
  line-height: 1.5;
  color: #495057;
  background-color: #fff;
  background-clip: padding-box;
  border: 1px solid #ced4da !important;
  border-radius: 0.25rem;
  transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
  position: relative;
}
</style>